class DeliveryDatesModal extends HTMLElement {
  /** @type {HTMLElement | null} */
  dialog = null;

  /** @type {HTMLButtonElement | null} */
  closeBtn = null;

  /** @type {HTMLElement | null} */
  triggerEl = null;

  /** @type {HTMLElement[]} */
  backgroundSiblings = [];

  /** @type {string} */
  focusableSelector = `
    a[href],
    button:not([disabled]),
    textarea:not([disabled]),
    input:not([disabled]),
    select:not([disabled]),
    [tabindex]:not([tabindex="-1"])
  `;

  connectedCallback() {
    this.dialog = this;
    this.closeBtn = /** @type {HTMLButtonElement | null} */ (
      this.querySelector('.rs-modal__close-button')
    );
    this.handleKeydown = this.handleKeydown.bind(this);
  }

  /**
   * @param {HTMLElement} triggerEl
   */
  open(triggerEl) {
  this.triggerEl = triggerEl;
  this.classList.remove('rs-hidden');

  this.setAttribute('role', 'dialog');
  this.setAttribute('aria-modal', 'true');

  document.addEventListener('keydown', this.handleKeydown, true);

  requestAnimationFrame(() => {
    const focusables = this.getFocusableElements();
    const firstFocusable = focusables[0];

    if (firstFocusable) {
      firstFocusable.focus();
    } else if (this.closeBtn) {
      this.closeBtn.focus();
    } else {
      this.focus();
    }
  });
}

  close() {
  this.classList.add('rs-hidden');

  document.removeEventListener('keydown', this.handleKeydown, true);

  if (this.triggerEl) {
    this.triggerEl.focus();
  }
}

  /**
   * @returns {HTMLElement[]}
   */
  getFocusableElements() {

     const modalElements = [...this.querySelectorAll(this.focusableSelector)];

  const flatpickrElements = [
    ...document.querySelectorAll('.flatpickr-calendar.open ' + this.focusableSelector),
    ...document.querySelectorAll('.flatpickr-calendar.open .flatpickr-day'),
    ...document.querySelectorAll('.flatpickr-calendar.open .flatpickr-prev-month'),
    ...document.querySelectorAll('.flatpickr-calendar.open .flatpickr-next-month')
  ];

    return [...modalElements, ...flatpickrElements]
      .filter(
        (el) =>
          el instanceof HTMLElement &&
          !el.hasAttribute('disabled') &&
          el.getAttribute('aria-hidden') !== 'true' &&
          el.tabIndex !== -1 &&
          el.offsetParent !== null
      )
      .map((el) => /** @type {HTMLElement} */ (el));
  }

  /**
 * @param {KeyboardEvent} e
 */
handleKeydown(e) {
  const active = document.activeElement;

  const activeInsideModal = this.contains(active);
  const activeInsideCalendar =
    active instanceof HTMLElement &&
    !!active.closest('.flatpickr-calendar.open');

  if (!activeInsideModal && !activeInsideCalendar) return;

  if (e.key === 'Escape') {
    e.preventDefault();
    this.close();
    return;
  }

  if (e.key !== 'Tab') return;

  const focusables = this.getFocusableElements();
  if (focusables.length === 0) return;

  const activeEl =
    document.activeElement instanceof HTMLElement
      ? document.activeElement
      : null;

  let currentIndex = activeEl ? focusables.indexOf(activeEl) : -1;

  if (currentIndex === -1) {
    const hostWithFocus = focusables.find((el) =>
      el.contains(document.activeElement)
    );
    if (hostWithFocus) {
      currentIndex = focusables.indexOf(hostWithFocus);
    }
  }

  if (currentIndex === -1) {
    e.preventDefault();
    focusables[0]?.focus();
    return;
  }

  e.preventDefault();

  const nextIndex = e.shiftKey
    ? currentIndex <= 0
      ? focusables.length - 1
      : currentIndex - 1
    : currentIndex >= focusables.length - 1
    ? 0
    : currentIndex + 1;

  focusables[nextIndex]?.focus();
}
}

if (!customElements.get('delivery-dates-modal')) {
  customElements.define('delivery-dates-modal', DeliveryDatesModal);
}